<template>
<div class="xin">
    <div class="switch">
        <el-tabs>
            <!-- 当前SMTP连接  -->
            <el-tab-pane label="当前SMTP连接">
                <span slot="label"> {{ $t("logs.smtpc") }}</span>
                <div class="switch1">
                    <div class="main">

                        <p class="main_list">
                            <el-select v-model="salt_minion_ip" @change="change1" size="smail" style="margin-right:4px" v-if="this.has_min==1">
                                <el-option v-for="item in minion_host" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>

                            {{$t('logs.xuhao1')}}
                            {{$t('logs.xuhao2')}}: <span style="margin:0 4px">{{ totalnums}}</span>
                            {{$t('logs.xuhao3')}}: <span style="margin:0 4px">{{ totalnums1}}</span>

                        </p>
                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" v-loading="loading">
                            <!-- 序号  -->

                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <!-- IP  -->

                            <el-table-column prop="IPADDR" :label="$t('logs.ip')">
                            </el-table-column>
                            <!-- 连接数量  -->

                            <el-table-column prop="CONN_NUM" :label="$t('logs.connect')">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="">

            </el-tab-pane>
        </el-tabs>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            salt_minion_ip: '127.0.0.1',
            salt_minion_ip1: [],
            minion_host: [],
            xian: false,
            btnText: "展示更多",
            checked: "",
            form: {
                username: "",
            },
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            tanchu: false,
            poptime: [{
                    value: "选项1",
                    label: "所以节点",
                },
                {
                    value: "选项2",
                    label: "211.100.61.211",
                },
                {
                    value: "选项3",
                    label: "211.100.61.209",
                },
                {
                    value: "选项4",
                    label: "211.100.47.36",
                },
                {
                    value: "选项5",
                    label: "本机",
                },
            ],

            emali: "",
            col: {
                a: "",
            },
            fileList: [],
            totalnums: '',
            totalnums1: '',
            has_min: '',
            loading:false,
        };
    },
    mounted() {
        this.getFileList();
    },
    methods: {
        // 下拉框点击选中
        change1(a) {
            // console.log(a);

            this.salt_minion_ip = a;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let salt_minion_ip = this.salt_minion_ip;

            // console.log(col, '5555')
            this.loading = true;

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "list_cur_conn",
                        sid: sid,
                        salt_minion_ip: salt_minion_ip,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");

                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')
            this.loading = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.pan = res.data.ret.HAS_MINION
                        // this.pan1 = res.data.ret.SYS_HAS_MULTI_MTA
                        // if (res.data.ret.HAS_MINION == 1) {
                        //     this.salt_minion_ip = res.data.ret.q_minion_host[0].label;
                        //     this.msalt_minion_ip1 = res.data.ret.col.salt_minion_ip;
                        //     this.minion_host = res.data.ret.q_minion_host;
                        // }
                        // if (res.data.ret.SYS_HAS_MULTI_MTA == 1) {
                        //     this.mta = res.data.ret.q_mta[0].label;
                        //     this.q_mta = res.data.ret.q_mta;
                        //     this.mmta1 = res.data.ret.col.mta;
                        // }

                        this.fileList = res.data.ret.datalist

                         this.totalnums = res.data.ret.totalnums;
                        this.totalnums1 = res.data.ret.curconnect;
                        // console.log(this.page)

                    }
                })
              
        },
        // 数据加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "list_cur_conn",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
 this.loading = false;
                        this.fileList = res.data.ret.datalist;

                        this.totalnums = res.data.ret.totalnums;
                        this.totalnums1 = res.data.ret.curconnect;
                        if (res.data.ret.HAS_MINION == 1) {
                            this.minion_host = res.data.ret.q_minion_host
                            this.has_min = 1
                            // this.salt_minion_ip = res.data.ret.q_minion_host[0].label
                        }
                        // console.log(this.page)

                    }
                })

        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
            this.tanchu1 = false;
        },
        tan4: function () {
            this.tanchu = true;
            //   this.tanchu1 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            //   this.tanchu1 = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.main {

    margin-bottom: 10px;

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    p {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
        font-family: PingFangSC-Medium, PingFang SC;

    }

}
</style>
